import { vgApiRequest } from "./vg-api.service";

export type UserOrganisation = {
  orgId: number;
  orgName: string;
};

type ReadAllUserOrgsResponse = {
  completeOrgList?: UserOrganisation[];
};

/** POST `Read_All_User_Organisations` — returns organisations the signed-in user can access. */
export async function fetchUserOrganisations(
  accessToken: string
): Promise<UserOrganisation[]> {
  const { data, error } = await vgApiRequest<ReadAllUserOrgsResponse>(
    accessToken,
    "Read_All_User_Organisations",
    {}
  );
  if (error) {
    console.warn("Read_All_User_Organisations failed", error);
    return [];
  }
  const list =
    data?.completeOrgList ??
    (data as { CompleteOrgList?: UserOrganisation[] })?.CompleteOrgList ??
    [];
  return list.map((o) => ({
    orgId: Number(o.orgId),
    orgName: String(o.orgName ?? ""),
  }));
}
